import React from 'react'
import GradientHeader from 'components/shared/GradientHeader'
import LabelTitleText from 'components/shared/LabelTitleText'
import EmbedTweet from 'components/shared/EmbedTweet'
import Head from 'next/head'
import classnames from 'classnames/bind'
import { ReactComponent as TwitterBadge } from './twitter-badge.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const EmbedTweets = ({ className, intro, gradientHeader, tweets }) => {
  return (
    <GradientHeader {...gradientHeader} className={cx(className)}>
      {intro && <LabelTitleText center {...intro} />}
      {tweets && (
        <>
          <TwitterBadge className={css.twitterBadge} />
          <div className={css.tweets}>
            {tweets.map(
              (tweet, index) =>
                tweet && (
                  <EmbedTweet key={index} className={css.tweet} {...tweet} />
                )
            )}
            <Head>
              <script
                data-cookieconsent="marketing"
                src="https://platform.twitter.com/widgets.js"
                charSet="utf-8"
              />
            </Head>
          </div>
        </>
      )}
    </GradientHeader>
  )
}

EmbedTweets.defaultProps = {}

export default EmbedTweets
